import { render, staticRenderFns } from "./PurchaseCard.vue?vue&type=template&id=f90ae0aa&scoped=true&lang=pug&"
import script from "./PurchaseCard.vue?vue&type=script&lang=js&"
export * from "./PurchaseCard.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseCard.vue?vue&type=style&index=0&id=f90ae0aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90ae0aa",
  null
  
)

export default component.exports